class WishlistShareButton extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.listId = this.getAttribute('list-id');
    this.listName = this.getAttribute('list-name');
    this.button = this.querySelector('button');
    this.modal = document.querySelector('#WishlistShareModal');
    this.shareForm = this.modal?.querySelector('wishlist-share-form');

    if (!this.modal) {
      this.hidden = true;
      return;
    }

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick(event) {
    event.preventDefault();

    if (!this.listId) {
      return console.error('No list ID', this.listId);
    }

    this.modal.show(event.currentTarget);
    this.shareForm.populate(this.listId, this.listName);
  }
}

customElements.define('wishlist-share', WishlistShareButton);

class WishlistShareForm extends ShareUrlForm {
  constructor() {
    super();
  }

  populate(listId, listName) {
    this.setAttribute('list-id', listId);
    this.setAttribute('list-name', listName);
    this.listId = listId;
    this.listName = listName;
    this.successMessage.hidden = true;
    this.form.hidden = false;

    if (!window.theme?.wishlist?.swat) {
      return console.error('Wishlist not loaded');
    }

    window.theme?.wishlist?.swat?.markListPublic(listId, this.onMakePublicSuccess.bind(this), this.onError.bind(this));
  }

  onMakePublicSuccess(response) {
    console.log('Successfully marked list as public', response);
    window.theme?.wishlist?.swat?.generateSharedListURL(response.lid, this.onGenerateURLSuccess.bind(this), this.onError.bind(this));
  }

  onGenerateURLSuccess(shareUrl, lid) {
    // Shared lists show "shared by <first name>"; Swish has no owner name, so it travels in the link
    const url = new URL(shareUrl);
    const firstName = this.senderName?.value?.trim().split(' ')[0];
    if (firstName) {
      url.searchParams.set('by', firstName);
    }
    console.log('Successfully Generated Link', url.toString());
    this.setShareUrls({
      url: url.toString(),
      title: this.listName || 'My Meshki collection'
    });
  }

  // Same email share as products: Klaviyo "Share Modal Submission" event, mailto fallback
  async onFormSubmit(event) {
    this.shareEventName = 'Share Modal Submission';
    this.shareEventData = { type: 'wishlist', listName: this.listName };
    await super.onFormSubmit(event);
    this.successMessage.hidden = false;
    this.form.hidden = true;
  }
}

customElements.define('wishlist-share-form', WishlistShareForm);

class WishlistCheckbox extends HTMLElement {
  constructor() {
    super();

    if (typeof window.wishlistCheckboxSelections == 'undefined') {
      window.wishlistCheckboxSelections = new Set();
    }

    this.isActive = false;
    this.maxSelections = 10;
  }

  connectedCallback() {
    this.product = {
      variantId: this.getAttribute('variant-id'),
      productId: this.getAttribute('product-id'),
      handle: this.getAttribute('product-handle'),
      image: this.getAttribute('product-image'),
    };

    this.button = this.querySelector('[data-wishlist-checkbox]') || this.querySelector('button');

    if (!this.button) {
      return;
    }

    this.button.addEventListener('click', this.onClick.bind(this));
  }

  onError(error) {
    // Error is an xhrObject
    console.error(error);
  }

  onClick(event) {
    event.preventDefault();
    if (window.wishlistCheckboxSelections.size >= this.maxSelections) {
      return;
    }
    this.isActive = !this.isActive;
    this.button.classList.toggle('is-active', this.isActive);
    if (this.isActive) {
      window.wishlistCheckboxSelections.add(this.product);
    } else {
      window.wishlistCheckboxSelections.delete(this.product);
    }
    document.body.classList.toggle('has-wishlist-selections', window.wishlistCheckboxSelections.size > 0);
  }
}

customElements.define('wishlist-checkbox', WishlistCheckbox);

class WishlistCheckboxControls extends HTMLElement {
  constructor() {
    super();

    if (typeof window.wishlistCheckboxSelections === 'undefined') {
      window.wishlistCheckboxSelections = new Set();
    }

    this.listId = null;

    const searchObj = window.Shopify.theme.helpers.getUrlSearchObj();
    if (searchObj && searchObj.listId) {
      this.listId = searchObj.listId;
    }
  }

  connectedCallback() {
    this.selectModal = document.querySelector('wishlist-select');
    this.addButton = this.querySelector('button[name="add"]');
    this.deleteButton = this.querySelector('button[name="delete"]');

    this.addButton.addEventListener('click', this.onAddClick.bind(this));

    if (this.listId) {
      this.deleteButton.addEventListener('click', this.onDeleteClick.bind(this));
    } else {
      this.deleteButton.hidden = true;
    }
  }

  removeSelection(variantId) {
    const gridCardEl = document.querySelector(`.grid__item[data-variant-id="${variantId}"]`);
    const setVal = Array.from(window.wishlistCheckboxSelections).find((x) => parseInt(x.variantId) === variantId);
    console.log('removeSelection', variantId, setVal, gridCardEl);
    // remove from grid
    gridCardEl?.remove();
    // remove from JS selections, update toolbar
    if (setVal) {
      window.wishlistCheckboxSelections.delete(setVal);
      document.body.classList.toggle('has-wishlist-selections', window.wishlistCheckboxSelections.size > 0);
    }
  }

  enableButtons() {
    this.addButton.disabled = false;
    this.deleteButton.disabled = false;
    this.addButton.classList.remove('is-loading');
    this.deleteButton.classList.remove('is-loading');
  }

  onDeleteSuccess(response) {
    console.log('Deleted ', response);
    this.enableButtons();
    const variantId = response.epi;
    if (response.length) {
      response.forEach((x) => {
        this.removeSelection(x.epi);
      });
    } else {
      this.removeSelection(response.epi);
    }
    // if no products left, delete the collection and redirect
    // to the listings page
    if (!document.querySelector(`.grid__item[data-variant-id]`)) {
      window.theme?.wishlist?.swat?.deleteList(
        this.listId,
        (response) => {
          console.log(response);
          window.location = window.wishlistSettings.homePageUrl;
        },
        this.onError.bind(this)
      );
    }
  }

  onError(error) {
    this.enableButtons();
    // Error is an xhrObject
    console.error(error);
  }

  onAddClick(event) {
    event.preventDefault();
    this.productsSelected = Array.from(window.wishlistCheckboxSelections);

    if (!this.productsSelected.length) {
      return;
    }

    this.addButton.disabled = true;
    this.deleteButton.disabled = true;
    this.addButton.classList.add('is-loading');

    this.selectModal.populateAndShow(null, this.productsSelected, [this.listId], undefined, () => {
      this.addButton.disabled = false;
      this.deleteButton.disabled = false;
      this.addButton.classList.remove('is-loading');
    });
  }

  deleteProducts() {
    const productsObject = this.selectModal.getProductObject(this.productsSelected);
    console.log('deleteProducts', this.productsSelected, productsObject);

    this.addButton.disabled = true;
    this.deleteButton.disabled = true;
    this.deleteButton.classList.add('is-loading');

    if (this.listId && productsObject.length > 1) {
      window.theme?.wishlist?.swat?.removeProductsFromList(
        this.listId,
        productsObject,
        this.onDeleteSuccess.bind(this),
        this.onError.bind(this)
      );
    } else if (this.listId) {
      window.theme?.wishlist?.swat?.deleteFromList(this.listId, productsObject, this.onDeleteSuccess.bind(this), this.onError.bind(this));
    } else {
    }
  }

  onDeleteClick(event) {
    event.preventDefault();
    this.productsSelected = Array.from(window.wishlistCheckboxSelections);

    if (!this.productsSelected.length) {
      return;
    }

    this.deleteProducts();
  }
}

customElements.define('wishlist-checkbox-controls', WishlistCheckboxControls);

class WishlistEditControls extends HTMLElement {
  constructor() {
    super();

    const searchObj = window.Shopify.theme.helpers.getUrlSearchObj();

    if (!searchObj || !searchObj.listId) {
      this.hidden = true;
      return;
    }

    this.listId = searchObj.listId;
  }

  connectedCallback() {
    this.thisModal = this.closest('modal-dialog');

    this.editButton = this.querySelector('button[name="edit"]');
    this.shareButton = this.querySelector('button[name="share"]');
    this.deleteButton = this.querySelector('button[name="delete"]');
    this.cancelButtons = this.querySelectorAll('button[name="cancel"]');
    this.renameSaveButton = this.querySelector('button[name="rename_list"]');
    this.deleteSaveButton = this.querySelector('button[name="delete_list"]');
    this.nameInput = this.querySelector('input[name="collection_name"]');
    this.homeScreen = this.querySelector('[data-screen="home"]');
    this.editScreen = this.querySelector('[data-screen="edit"]');
    this.deleteScreen = this.querySelector('[data-screen="delete"]');
    this.shareModal = document.querySelector('#WishlistShareModal');

    if (!this.shareModal) {
      this.shareButton.hidden = true;
    }

    this.shareButton.addEventListener('click', this.onShareClick.bind(this));
    this.editButton.addEventListener('click', this.onEditClick.bind(this));
    this.deleteButton.addEventListener('click', this.onDeleteClick.bind(this));
    this.deleteSaveButton.addEventListener('click', this.onDeleteSaveClick.bind(this));
    this.renameSaveButton.addEventListener('click', this.onRenameSaveClick.bind(this));

    this.cancelButtons.forEach((x) => x.addEventListener('click', this.onCancel.bind(this)));

    if (this.nameInput && window.wishlistSettings.listName) {
      this.nameInput.value = window.wishlistSettings.listName;
    }
  }

  onEditClick(event) {
    event.preventDefault();

    if (this.nameInput && window.wishlistSettings.listName) {
      this.nameInput.value = window.wishlistSettings.listName;
    }

    this.homeScreen.hidden = true;
    this.editScreen.hidden = false;
  }

  onShareClick(event) {
    event.preventDefault();

    // Carry the opener over since this button's modal is about to be hidden.
    const opener = this.thisModal.openedBy;
    this.thisModal.hide();
    this.shareModal.closest('modal-dialog').show(opener);
  }

  onRenameSaveClick(event) {
    event.preventDefault();

    const listUpdateConfig = {
      lid: this.listId,
      lname: this.nameInput.value,
    };

    window.theme?.wishlist?.swat?.updateList(
      listUpdateConfig,
      (response) => {
        console.log(response);
        this.closeUp();
        if (response.lname) {
          Array.from(document.querySelectorAll('[data-wishlist-page-title]')).forEach((x) => {
            x.innerText = response.lname;
          });
          if (window.wishlistSettings.listName) {
            window.wishlistSettings.listName = response.lname;
          }
        }
      },
      this.onError.bind(this)
    );
  }

  onDeleteSaveClick(event) {
    event.preventDefault();

    window.theme?.wishlist?.swat?.deleteList(
      this.listId,
      (response) => {
        console.log(response);
        window.location = window.wishlistSettings.homePageUrl;
      },
      this.onError.bind(this)
    );
  }

  onDeleteClick(event) {
    event.preventDefault();
    this.homeScreen.hidden = true;
    this.deleteScreen.hidden = false;
  }

  resetModal() {
    this.homeScreen.hidden = false;
    this.deleteScreen.hidden = true;
    this.editScreen.hidden = true;
  }

  closeUp() {
    this.resetModal();
    this.thisModal.hide();
  }

  onCancel(event) {
    event.preventDefault();
    this.closeUp();
  }

  onError(error) {
    // Error is an xhrObject
    console.error(error);
  }
}

customElements.define('wishlist-edit-controls', WishlistEditControls);

class WishlistEditButton extends HTMLElement {
  constructor() {
    super();

    const searchObj = window.Shopify.theme.helpers.getUrlSearchObj();

    if (!searchObj || !searchObj.listId) {
      this.hidden = true;
      return;
    }

    this.listId = searchObj.listId;
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll('button');
    this.editComponent = document.querySelector('wishlist-edit-controls');

    if (!this.buttons.length) {
      return;
    }

    this.editModal = this.editComponent.closest('modal-dialog');

    if (!this.editModal) {
      this.hidden = true;
      return;
    }

    for (const button of this.buttons) {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        this.editModal?.show(event.currentTarget);
      });
    }
  }
}

customElements.define('wishlist-edit-button', WishlistEditButton);
